<template>
  <div>
    <px-view-header title="Centro de Custo" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-centro-custo-list-header :on-click-refresh="onClickRefresh"
                                 :on-change-filter="onChangeFilter" />
    <px-centro-custo-list :centros-custo="centrosCusto"
                          :loading="loading"
                          :on-change-options="onChangeOptions"
                          :options-list="optionsList"
                          @remove="onRemove" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import paginationMixin from '@/mixins/pagination-mixin';
import CentroCustoService from './centro-custo-service';
import CentroCustoList from './CentroCustoList.vue';
import CentroCustoListHeader from './CentroCustoListHeader.vue';

export default {
  mixins: [paginationMixin],
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Centros de custo' },
      ],
      centrosCusto: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 10,
        offset: 0,
        filter: '',
        sort: 'descricao',
        sortDesc: false,
      },
      optionsList: {},
    };
  },
  computed: {
    ...mapGetters('listagemCentroCusto', ['stringFilter']),
  },
  methods: {
    onChangeFilter() {
      this.listOptions.filter = this.stringFilter;
      this.resetPage();
      this.getCentroCusto();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getCentroCusto();
    },
    onClickRefresh() {
      this.getCentroCusto();
    },
    onRemove(item) {
      this.loading = true;
      CentroCustoService.remover(item.id)
        .then(() => {
          this.$toast('Centro de custo removido com sucesso', { color: 'success' });
          this.getCentroCusto();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getCentroCusto() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return CentroCustoService.getList({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.centrosCusto = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.listOptions.filter = this.stringFilter;
  },
  components: {
    pxCentroCustoList: CentroCustoList,
    pxCentroCustoListHeader: CentroCustoListHeader,
  },
};

</script>
